import { t } from '@lingui/core/macro'
import { useMemo } from 'react'
import Col from 'react-bootstrap/Col'
import MultiSelect from '~/components/multi_select'
import Select from '~/components/select'
import DashboardFilters from '~/dashboard/dashboard_filters'
import useChartFilters from '~/hooks/use_chart_filters'
import { azureLocationsChartOptionPath, azureSubscriptionsChartOptionPath } from '~/routes'
import { azureCostKinds } from '~/utils/azure'

export default function AzureVirtualMachinesDashboardFilters({ organizationId: orgId, setChartParams }) {
  const [onApply, onReset, onChange, params] = useChartFilters(setChartParams)

  const subscriptionsUrl = useMemo(() => azureSubscriptionsChartOptionPath(orgId), [orgId])
  const locationsUrl = useMemo(() => azureLocationsChartOptionPath(orgId), [orgId])

  return (
    <DashboardFilters onApply={onApply} onReset={onReset}>
      <Col>
        <MultiSelect
          label={t`Subscription`}
          name='azureSubscriptionIds'
          onChange={onChange}
          url={subscriptionsUrl}
          selected={params.azureSubscriptionIds}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Locations`}
          name='azureResourceLocations'
          onChange={onChange}
          url={locationsUrl}
          params={params}
          selected={params.azureResourceLocations}
        />
      </Col>
      <Col>
        <Select
          label={t`Cost Kind`}
          name='azureCostKind'
          onChange={onChange}
          options={azureCostKinds()}
          selected={params.azureCostKind}
        />
      </Col>
    </DashboardFilters>
  )
}
